import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import * as S from './AppQrPopup.styles'
import Popup from 'components/Popup/Popup'
import { ReactComponent as CloseIcon } from 'icons/assets/X.svg'
// Encodes MULTI_PRODUCT_APP_ONELINK.oneLinkUrl. If the link changes, regenerate with
// `npx qrcode -t svg -e M -q 0 -o app-qr-code.svg <url>`.
import { ReactComponent as AppQrCode } from 'images/homePage/app-qr-code.svg'

type Props = {
  onClose: () => void
}

export default function AppQrPopup({ onClose }: Props) {
  const { t } = useTranslation()
  const titleId = useId()

  return (
    <Popup
      onClose={onClose}
      dialogStyles={S.POPUP_PAPER_STYLES}
      ariaLabelledBy={titleId}
    >
      <S.Container data-testid="app-qr-popup">
        <S.CloseButton
          type="button"
          onClick={onClose}
          aria-label={t('order.checkout.add_gift_note_options.close')}
          data-testid="app-qr-popup-close"
        >
          <CloseIcon />
        </S.CloseButton>
        <S.Title id={titleId}>
          {t('multi_product_homepage.get_app_title')}
        </S.Title>
        <S.QrCode data-testid="app-qr-code">
          <AppQrCode aria-hidden />
        </S.QrCode>
      </S.Container>
    </Popup>
  )
}
